import IconSend from "../../common/icons/IconSend";
import IconSetting from "../../common/icons/IconSetting";
import IconPen from "../../common/icons/IconPen";
import "./QuestionInput.css";
import "react-toastify/dist/ReactToastify.css";
import Rating from "../rating/Rating";
import { useState, useEffect, useRef } from "react";
import IconDelete from "../../common/icons/IconDelete";
import { AI_BASE_URL } from "../../config/index";
import Silos from "../silos/silos";

const QuestionInput = ({
  handleSend,
  setTextInput,
  text,
  bottom,
  isOpen,
  disabled,
  showRating,
  record,
  onRatingSubmit,
  onSkipRating,
  setCustomPrompt,
  token,
  user,
  userSilots,
  loadingSilots,
  handleSetSilos,
  allSilosExpiredOrMissing,
  silos = [],
  silosModalTrigger,
}) => {
  // const [showPromptPopup, setShowPromptPopup] = useState(false);
  // const [prompts, setPrompts] = useState([]);
  // const [editingPrompt, setEditingPrompt] = useState(null);
  // const [newPromptTitle, setNewPromptTitle] = useState("");
  // const [newPromptText, setNewPromptText] = useState("");
  // const [selectedPromptId, setSelectedPromptId] = useState(null);
  // const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  // const [deletingPromptId, setDeletingPromptId] = useState(null);
  const [isTypingOnMobile, setIsTypingOnMobile] = useState(false);
  const dbIconWrapperRef = useRef(null);
  const [localText, setLocalText] = useState(text);

  useEffect(() => {
    setLocalText(text);
  }, [text]);

  // useEffect(() => {
  //   const fetchPrompts = async () => {
  //     try {
  //       const response = await fetch(`${AI_BASE_URL}/prompts`);
  //       if (response.ok) {
  //         const data = await response.json();
  //         const userPrompts = data.filter((p) => p.user_id === user.id);
  //         setPrompts(userPrompts);

  //         // Load saved prompt from localStorage
  //         const storedPromptId = localStorage.getItem(
  //           `selectedPromptId-${user.id}`
  //         );
  //         if (storedPromptId) {
  //           const selectedPrompt = userPrompts.find(
  //             (p) => p.id === parseInt(storedPromptId)
  //           );
  //           if (selectedPrompt) {
  //             setSelectedPromptId(selectedPrompt.id);
  //             setCustomPrompt(selectedPrompt.prompt);
  //           }
  //         }
  //       }
  //     } catch (error) {
  //       console.error("Error fetching prompts:", error);
  //     }
  //   };
  //         // Load saved prompt from localStorage
  //         const storedPromptId = localStorage.getItem(
  //           `selectedPromptId-${user.id}`
  //         );
  //         if (storedPromptId) {
  //           const selectedPrompt = userPrompts.find(
  //             (p) => p.id === parseInt(storedPromptId)
  //           );
  //           if (selectedPrompt) {
  //             setSelectedPromptId(selectedPrompt.id);
  //             setCustomPrompt(selectedPrompt.prompt);
  //           }
  //         }
  //       }
  //     } catch (error) {
  //       console.error("Error fetching prompts:", error);
  //     }
  //   };

  //   if (showPromptPopup) {
  //     fetchPrompts();
  //   }
  // }, [showPromptPopup, user.id, setCustomPrompt]);
  //   if (showPromptPopup) {
  //     fetchPrompts();
  //   }
  // }, [showPromptPopup, user.id, setCustomPrompt]);

  // Check for overflow in the db-icon-popup-wrapper
  useEffect(() => {
    const checkForOverflow = () => {
      if (dbIconWrapperRef.current) {
        const hasOverflow =
          dbIconWrapperRef.current.scrollWidth >
          dbIconWrapperRef.current.clientWidth;
        if (hasOverflow) {
          dbIconWrapperRef.current.classList.add("has-overflow");
        } else {
          dbIconWrapperRef.current.classList.remove("has-overflow");
        }
      }
    };

    // Check on initial render and window resize
    checkForOverflow();
    window.addEventListener("resize", checkForOverflow);

    return () => {
      window.removeEventListener("resize", checkForOverflow);
    };
  }, [userSilots]); // Re-check when silos change

  // const handleSavePrompt = async (e) => {
  //   e.preventDefault();
  //   if (!newPromptTitle || !newPromptText) return;

  //   const apiUrl = editingPrompt
  //     ? `${AI_BASE_URL}/prompts/${editingPrompt.id}`
  //     : `${AI_BASE_URL}/prompts`;
  //   const method = editingPrompt ? "PUT" : "POST";

  //   try {
  //     const response = await fetch(apiUrl, {
  //       method,
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({
  //         title: newPromptTitle,
  //         prompt: newPromptText,
  //         user_id: user.id,
  //       }),
  //     });

  //     if (response.ok) {
  //       const savedPrompt = await response.json();
  //       if (editingPrompt) {
  //         setPrompts(
  //           prompts.map((p) => (p.id === savedPrompt.id ? savedPrompt : p))
  //         );
  //       } else {
  //         setPrompts([...prompts, savedPrompt]);
  //       }
  //       setNewPromptTitle("");
  //       setNewPromptText("");
  //       setEditingPrompt(null);
  //     }
  //   } catch (error) {
  //     console.error("Error saving prompt:", error);
  //   }
  // };

  // const handleSelectPrompt = (prompt) => {
  //   setSelectedPromptId(prompt.id);
  //   setCustomPrompt(prompt.prompt);
  //   localStorage.setItem(`selectedPromptId-${user.id}`, prompt.id);
  // };

  // const handleInitiateDelete = (promptId) => {
  //   setDeletingPromptId(promptId);
  //   setShowDeleteConfirmation(true);
  // };

  // const handleConfirmDelete = async () => {
  //   if (!deletingPromptId) return;

  //   try {
  //     const response = await fetch(
  //       `${AI_BASE_URL}/prompts/${deletingPromptId}`,
  //       {
  //         method: "DELETE",
  //       }
  //     );

  //     if (response.ok) {
  //       setPrompts(prompts.filter((p) => p.id !== deletingPromptId));
  //       if (selectedPromptId === deletingPromptId) {
  //         setCustomPrompt("");
  //         setSelectedPromptId(null);
  //         localStorage.removeItem(`selectedPromptId-${user.id}`);
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error deleting prompt:", error);
  //   } finally {
  //     setShowDeleteConfirmation(false);
  //     setDeletingPromptId(null);
  //   }
  // };

  const handleChange = (event) => {
    setLocalText(event.target.value);
    setTextInput(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey && !disabled) {
      event.preventDefault();
      handleSend();
    }
  };

  const handleFocus = () => {
    if (window.innerWidth <= 600) {
      setIsTypingOnMobile(true);
    }
  };

  const handleBlur = () => {
    if (window.innerWidth <= 600) {
      setIsTypingOnMobile(false);
    }
  };

  // const DeleteConfirmationModal = () => (
  //   <div
  //     className="delete-confirmation-overlay"
  //     onClick={() => setShowDeleteConfirmation(false)}
  //   >
  //     <div
  //       className="delete-confirmation-modal"
  //       onClick={(e) => e.stopPropagation()}
  //     >
  //       <h3>Confirm Deletion</h3>
  //       <p>Are you sure you want to delete this prompt?</p>
  //       <div className="confirmation-buttons">
  //         <button
  //           className="cancel-button"
  //           onClick={() => setShowDeleteConfirmation(false)}
  //         >
  //           Cancel
  //         </button>
  //         <button
  //           className="confirm-delete-button"
  //           onClick={handleConfirmDelete}
  //         >
  //           Delete
  //         </button>
  //       </div>
  //     </div>
  //   </div>
  // );

  const isButtonActive =
    localText.trim() && !allSilosExpiredOrMissing && silos.length > 0;

  return (
    <>
      <div
        className={
          "text-area-container" +
          (bottom ? " bottom" : "") +
          (isOpen ? " open" : "") +
          (showRating ? " rating-required" : "")
        }
      >
        <div className="background-blur"></div>
        <div className="textarea-wrapper">
          {showRating && record ? (
            <Rating
              reviewId={record.id}
              onRatingSubmit={onRatingSubmit}
              onSkipRating={onSkipRating}
              token={token}
            />
          ) : (
            <>
              <textarea
                value={localText}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                onFocus={handleFocus}
                onBlur={handleBlur}
                placeholder={
                  allSilosExpiredOrMissing
                    ? "Aucune source disponible. Veuillez vérifier vos accès."
                    : "Tapez votre message..."
                }
                rows={4}
                cols={50}
                disabled={allSilosExpiredOrMissing}
              />
            </>
          )}
          <div>
            <div
              className={`silos-wrapper ${
                isTypingOnMobile ? "mobile-typing" : ""
              }`}
            >
              {loadingSilots ? (
                <div className="silo-skeleton-container">
                  <div className="silo-skeleton-pill"></div>
                  <div className="silo-skeleton-pill"></div>
                  <div className="silo-skeleton-pill"></div>
                  <div className="silo-skeleton-pill"></div>
                  <div className="silo-skeleton-pill"></div>
                </div>
              ) : (
                !showRating &&
                userSilots?.length > 0 && (
                  <>
                    <Silos
                      setSilos={handleSetSilos}
                      user={user}
                      userSilots={userSilots}
                      token={token}
                      externalTrigger={silosModalTrigger}
                    />{" "}
                    {/* {user.id === 8650 && ( */}
                    {/*   <> */}
                    {/*     <div className="prompt-separator"></div> */}
                    {/*     <button */}
                    {/*       className="prompt-button" */}
                    {/*       onClick={() => setShowPromptPopup(true)} */}
                    {/*       title="Gérer les prompts personnalisés" */}
                    {/*     > */}
                    {/*       <IconSetting /> */}
                    {/*     </button> */}
                    {/*   </> */}
                    {/* )} */}
                  </>
                )
              )}
            </div>
          </div>
        </div>
        {!showRating && (
          <button
            className={`send-button ${isButtonActive ? "active" : ""}`}
            onClick={handleSend}
            disabled={
              disabled ||
              !isButtonActive ||
              allSilosExpiredOrMissing ||
              silos.length === 0
            }
          >
            <IconSend />
          </button>
        )}
      </div>

      {/* {showPromptPopup && ( */}
      {/*   <div */}
      {/*     className="prompt-popup-overlay" */}
      {/*     onClick={() => setShowPromptPopup(false)} */}
      {/*   > */}
      {/*     <div className="prompt-popup" onClick={(e) => e.stopPropagation()}> */}
      {/*       <div className="prompt-management"> */}
      {/*         <div className="prompt-form"> */}
      {/*           <h3> */}
      {/*             {editingPrompt ? "Modifier le Prompt" : "Nouveau Prompt"} */}
      {/*           </h3> */}
      {/*           <input */}
      {/*             type="text" */}
      {/*             placeholder="Titre du Prompt" */}
      {/*             value={newPromptTitle} */}
      {/*             onChange={(e) => setNewPromptTitle(e.target.value)} */}
      {/*             maxLength={200} */}
      {/*           /> */}
      {/*           <textarea */}
      {/*             placeholder="Contenu du Prompt" */}
      {/*             value={newPromptText} */}
      {/*             onChange={(e) => setNewPromptText(e.target.value)} */}
      {/*             maxLength={5000} */}
      {/*           /> */}
      {/*           <button */}
      {/*             className="save-prompt-button" */}
      {/*             onClick={handleSavePrompt} */}
      {/*             disabled={!newPromptTitle || !newPromptText} */}
      {/*           > */}
      {/*             {editingPrompt ? "Mettre à jour" : "Enregistrer"} */}
      {/*           </button> */}
      {/*         </div> */}

      {/*         <div className="prompts-list"> */}
      {/*           <h3>Prompts Enregistrés</h3> */}
      {/*           <div className="prompts-container"> */}
      {/*             {prompts.map((prompt) => ( */}
      {/*               <div key={prompt.id} className="prompt-item"> */}
      {/*                 <label> */}
      {/*                   <input */}
      {/*                     type="radio" */}
      {/*                     name="selectedPrompt" */}
      {/*                     checked={selectedPromptId === prompt.id} */}
      {/*                     onChange={() => handleSelectPrompt(prompt)} */}
      {/*                   /> */}
      {/*                   <span className="prompt-title">{prompt.title}</span> */}
      {/*                 </label> */}
      {/*                 <div className="prompt-actions"> */}
      {/*                   <button */}
      {/*                     className="edit-button" */}
      {/*                     onClick={() => { */}
      {/*                       setEditingPrompt(prompt); */}
      {/*                       setNewPromptTitle(prompt.title); */}
      {/*                       setNewPromptText(prompt.prompt); */}
      {/*                     }} */}
      {/*                   > */}
      {/*                     <IconPen /> */}
      {/*                   </button> */}
      {/*                   <button */}
      {/*                     className="delete-button" */}
      {/*                     onClick={() => handleInitiateDelete(prompt.id)} */}
      {/*                   > */}
      {/*                     <IconDelete /> */}
      {/*                   </button> */}
      {/*                 </div> */}
      {/*               </div> */}
      {/*             ))} */}
      {/*           </div> */}
      {/*         </div> */}
      {/*       </div> */}
      {/*       <button */}
      {/*         className="close-popup-button" */}
      {/*         onClick={() => setShowPromptPopup(false)} */}
      {/*       > */}
      {/*         Fermer */}
      {/*       </button> */}
      {/*     </div> */}
      {/*   </div> */}
      {/* )} */}

      {/* {showDeleteConfirmation && ( */}
      {/*   <div */}
      {/*     className="delete-confirmation-overlay" */}
      {/*     onClick={() => setShowDeleteConfirmation(false)} */}
      {/*   > */}
      {/*     <div */}
      {/*       className="delete-confirmation-modal" */}
      {/*       onClick={(e) => e.stopPropagation()} */}
      {/*     > */}
      {/*       <h3>Confirmer la suppression</h3> */}
      {/*       <p>Êtes-vous sûr de vouloir supprimer ce prompt ?</p> */}
      {/*       <div className="confirmation-buttons"> */}
      {/*         <button */}
      {/*           className="cancel-button" */}
      {/*           onClick={() => setShowDeleteConfirmation(false)} */}
      {/*         > */}
      {/*           Annuler */}
      {/*         </button> */}
      {/*         <button */}
      {/*           className="confirm-delete-button" */}
      {/*           onClick={handleConfirmDelete} */}
      {/*         > */}
      {/*           Supprimer */}
      {/*         </button> */}
      {/*       </div> */}
      {/*     </div> */}
      {/*   </div> */}
      {/* )} */}
    </>
  );
};

export default QuestionInput;
